import { render, staticRenderFns } from "./temperature-range.vue?vue&type=template&id=3531f9d8&"
import script from "./temperature-range.vue?vue&type=script&lang=js&"
export * from "./temperature-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports